<ng-container *ngIf="data.entitlement.canCreate; else limitContent">
  <h2 mat-dialog-title>Create {{data.entitlement.taxYear}} Tax Plan?</h2>
  <mat-dialog-content>
    <p>
      You are on the Basic subscription. By creating this plan, you'll use credit
      {{data.entitlement.nextCredit}} of {{data.entitlement.limit}} for your current subscription
      term<ng-container *ngIf="termLastDay"> (through {{termLastDay}})</ng-container>. You can make
      unlimited changes to this plan after it's created.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">Cancel</button>
    <button mat-flat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Create Plan</button>
  </mat-dialog-actions>
</ng-container>


<ng-template #limitContent>
  <h2 mat-dialog-title>Basic Plan Limit Reached</h2>
  <mat-dialog-content>
    <p *ngIf="!isOverLimit">
      Your firm has created {{data.entitlement.used}} plans this subscription term and has reached the
      maximum included with the Basic subscription.<ng-container *ngIf="termResetDate"> Your credits
      reset on {{termResetDate}}.</ng-container>
    </p>
    <p *ngIf="isOverLimit">
      Your firm already has {{data.entitlement.used}} plans this subscription term and another plan cannot
      be created this term with the Basic subscription.<ng-container *ngIf="termResetDate"> Your credits
      reset on {{termResetDate}}.</ng-container>
    </p>
    <p>Use the Upgrade link below the plan counter to request an upgrade.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" [mat-dialog-close]="false">Close</button>
  </mat-dialog-actions>
</ng-template>
